import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');

// react-snap ke prerendered HTML ko hydrate karo; warna normal render.
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
